import type { RouteRecordRaw } from 'vue-router'

// Placeholder for the secondary-market SELL flow — listing a holding for
// resale, managing active listings, cancelling. The buy flow lives in the
// sibling marketplace/invest/. Discovery lives in marketplace/browse/.
export const marketplaceSellRoutes: RouteRecordRaw[] = []
